import React, {useEffect, useRef, useState} from 'react';
import {isEmpty} from "lodash";
import {numberWithCommas} from "../commonmethod/CommonMethod";

/**
 * update : 등록페이지가 아니라 수정페이지일 경우
 * */

/*
* Todo api로딩이 안된건지 값 자체가 없는건지 구분해서 skeleton 을 보여줘야 한다.
* */
function SimmsInput({data, style, onChange, onKeyDown, constraint: _constraint, update, auth, clicked, setClicked, placeHolder, type, ...rest}) {

    const [value, setValue] = useState(data || "");
    const [localClicked, setLocalClicked] = useState(false);
    const hasParentClickState = typeof setClicked === "function";
    const isClicked = hasParentClickState ? !!clicked : localClicked;
    const setClickState = hasParentClickState ? setClicked : setLocalClicked;

    useEffect(() => {
        setValue(data || "");
    }, [data]);
    const inputStyle = {width: '100%', ...style};
    const inputRef = useRef(null);
    const handleSpanClick = () => {
        setClickState(true);
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    };
    const handleChange = (e) => {
        setValue(e.target.value)
        if(!update){
            onChange(e.target.value);
        }
    }

    const handleKeyDown = (e) => {
        // esc키 > 기존값 복원
        if (e.key === "Escape") {
            setValue(data);
            setClickState(false);
            return;
        }

        // enter 시 blur처리
        if (e.key === "Enter") {
            inputRef.current?.blur();
        }
    }

    // blur시 update
    /** 상세(update): fieldAuth 있을 때만 클릭→인라인 수정. 보기 모드에서는 읽기 전용 텍스트만 */
    const fieldEditable = !update || !!auth;
    const showInput = !update || (!!auth && isClicked);

    const handleBlur = async (e) => {
        const {duplicate} = {...rest}

        // 공백비교
        if(isEmpty(data) && isEmpty(value)) {
            setClickState(false);
            return;
        }

        // 데이터비교
        if(data === value){
            setClickState(false);
            return;
        }

        if (typeof duplicate === 'function'){
            const r = await duplicate(value);
            if(r?.status === 201 || r?.status === 202){
                setValue(data);
                return;
            }
        }

        // 수정페이지에서만 사용
        // eslint-disable-next-line no-restricted-globals
        if(confirm("수정하시겠습니까?")) {
            if (update) onKeyDown(value, e);
        }else{
            setValue(data ?? "");
        }

        setClickState(false);
    }

    const displayValue =
        type && type === "number" ? numberWithCommas(data) : (data ?? placeHolder);

    return (
        <>
            {showInput ?
                <input
                    ref={inputRef}
                    type={type ?? "text"}
                    className={`basic-input simms-input ${!update ? 'input-style' : ''}`}
                    style={inputStyle}
                    onBlur={handleBlur}
                    {...rest}
                    value={value}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    maxLength={255}
                />
                :
                <span
                    className={fieldEditable ? "edit-input" : "asset-detail-kv-value"}
                    onClick={fieldEditable ? handleSpanClick : undefined}
                >
                    {displayValue}
                </span>
            }
        </>
    );
}

export default SimmsInput;